import TextUtil from "../../../../lib/html5-software-library/src/ranj/components/text/TextUtil";
import SkinKey from "./SkinKey";

/**
 * SkinFactory keys are injected by various installers.
 * See AppInstaller.js etc
 */
const SkinFactory = {
    fontMappings: [],
    fontSizeOffset: 0,
    lineHeightOffset: 0
};
export default SkinFactory;

SkinFactory.registerFontMapping = function (from, to) {
    SkinFactory.fontMappings.push({
        from,
        to
    });
};

/**
 * Registers font size and line height offsets to be applied to any createjs.Text
 * @param {number} fontOffset value added to all font sizes
 * @param {number} lineHeightOffset value added to all line height
 */
SkinFactory.registerTextOffset = function(fontOffset = 0, lineHeightOffset = 0) {
    SkinFactory.fontSizeOffset = fontOffset;
    SkinFactory.lineHeightOffset = lineHeightOffset;
};

/**
 * Static method that returns a skin (DisplayObject) based on screen name
 * @param {SkinKey} key - Object with property 'skinClass'
 * @return {createjs.DisplayObject}
 */
SkinFactory.getSkin = function (key) {

    const skin = new key.skinClass();

    //Set skinType property for MediatorManager to spawn corresponding mediator
    skin.skinType = key;

    if (!!skin) {
        SkinFactory.mapFonts(skin);
    }

    return skin;
};

/**
 * Replaces fonts in requested skins for each font mapping that exists
 * @param {createjs.MovieClip} skin 
 */
SkinFactory.mapFonts = function (skin) {
    if (!!skin.children) {
        for (let i = 0; i < skin.children.length; i++) {
            SkinFactory.mapFonts(skin.children[i]);
        }
        return;
    }
    
    if (skin instanceof createjs.Text) {
        /** @type {createjs.Text} */
        const textField = skin;
        // NB: keep original text information and metrics before any changes, in order to facilitate text size operations
        // NB: changing font or text size immediately affects the measured metrics
        textField.original = {
            font: textField.font,
            measuredHeight: textField.getMeasuredHeight(),
            measuredWidth: textField.getMeasuredWidth(),
            x: textField.x,
            y: textField.y,
            lineHeight: textField.lineHeight,
            lineWidth: textField.lineWidth
        };
        // apply font mapping - if any
        const fontName = TextUtil.getFontName(textField);
        const fontMapping = SkinFactory.fontMappings.find(m => m.from === fontName);
        if(fontMapping) {
            textField.font = textField.font.replace(`'${fontMapping.from}'`, `'${fontMapping.to}'`);
        }
        // apply font offset - if any
        if(SkinFactory.fontSizeOffset !== 0) {
            const newFontSize = TextUtil.getFontSize(textField) + SkinFactory.fontSizeOffset;
            TextUtil.setFontSize(textField, newFontSize);
        }
        // apply line height offset - if any
        if(SkinFactory.lineHeightOffset !== 0) {
            textField.lineHeight += SkinFactory.lineHeightOffset;
        }
    }
};

SkinFactory.cloneTextField = function(textField) {
    const clone = textField.clone();
    clone.original = !!textField.original ? JSON.parse(JSON.stringify(textField.original)) : null;
    return clone;
};